import { render, staticRenderFns } from "./InvoiceFieldsForm.vue?vue&type=template&id=46ca574c&scoped=true"
import script from "./InvoiceFieldsForm.vue?vue&type=script&lang=js"
export * from "./InvoiceFieldsForm.vue?vue&type=script&lang=js"
import style0 from "./InvoiceFieldsForm.vue?vue&type=style&index=0&id=46ca574c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46ca574c",
  null
  
)

export default component.exports